"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const base_models_1 = require("@integration/base-models");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
class GetModelContractQuery extends base_models_1.Serializable {
    constructor() {
        super(...arguments);
        this.duration = base_models_1.DurationInYears.FLEX;
        this.residential = true;
    }
}
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.IsAddressKey)(),
    (0, class_transformer_1.Expose)({ name: 'address_key' }),
    (0, base_models_1.Docs)({
        example: '1234AX_9_B',
        description: `The address for which you want the tariffs.
Based on the address the call is made to EDSN to fetch the grid operator and net area.
The net area is used only for gas tariffs. And the grid operator is used to fetch the default captar code.
These combined give the netbeheerder kosten.`,
    }),
    tslib_1.__metadata("design:type", String)
], GetModelContractQuery.prototype, "addressKey", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsIn)(Object.values(base_models_1.SegmentType)),
    (0, base_models_1.Docs)({
        example: base_models_1.SegmentType.HH,
        description: `Describes for which function the building for the given address is being used.
AOM smashes household and Small Office/Home Office (SOHO) together and all other segments as small medium enterprise.
Since different laws apply for households and non-households. This influences all the cost: netbeheerder, levering and belasting.`,
    }),
    tslib_1.__metadata("design:type", String)
], GetModelContractQuery.prototype, "segment", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)({ name: 'campaign_id' }),
    (0, base_models_1.Docs)({
        example: '14259',
        description: `This should be the model contract campaign.
This influence the levering kosten. For any question regarding the campaign, contact the Campaign Management team.`,
    }),
    tslib_1.__metadata("design:type", String)
], GetModelContractQuery.prototype, "campaignId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsIn)(Object.values(base_models_1.DurationInYears)),
    (0, base_models_1.Docs)({
        example: base_models_1.DurationInYears.FIVE,
        description: `The duration of the contact. Defaults to flex also known as 99.
This influences the proposition that is picked. The duration should exist for the given campaign. Otherwise you will get a 400.
Contact the Campaign Management team or I Pay AOM to know which durations are avaible for the campaign.
There is no API to get this information.`,
    }),
    tslib_1.__metadata("design:type", String)
], GetModelContractQuery.prototype, "duration", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    (0, base_models_1.ConvertToBoolean)(),
    (0, base_models_1.Docs)({
        example: true,
        description: `If the building on the given address is being used as a living place (woonfunctie).
This must be provided by the user. We are not allowed to guess or fetch this from BAG by law!`,
    }),
    tslib_1.__metadata("design:type", Boolean)
], GetModelContractQuery.prototype, "residential", void 0);
exports.default = GetModelContractQuery;
